export default __webpack_public_path__ + "static/media/all-icon.4ad4106d.svg";